"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeFromInventory = exports.tryMoveOffset = exports.damage = exports.getAt = exports.drawAll = exports.runAll = exports.killAllButPlayer = exports.killAllEvenIncludingThePlayer = exports.kill = exports.pickupItem = exports.setPos = exports.getPlayer = exports.create = void 0;
var entitiesUtils_sidecar_1 = require("../../../entities/entitiesUtils-sidecar");
var assert_sidecar_1 = require("../../../lib/assert-sidecar");
var common_sidecar_1 = require("../../../main/common-sidecar");
var sprites_sidecar_1 = require("../../../sprites/sprites-sidecar");
var spritesUtil_sidecar_1 = require("../../../sprites/spritesUtil-sidecar");
var rogueDungeonFeatures_sidecar_1 = require("../items/rogueDungeonFeatures-sidecar");
var rogueItems_sidecar_1 = require("../items/rogueItems-sidecar");
var rogueMaps_1 = require("../map/rogueMaps");
var rogueMaps_sidecar_1 = require("../map/rogueMaps-sidecar");
var rogueMonofont_sidecar_1 = require("../monofont/rogueMonofont-sidecar");
var rogueDef_sidecar_1 = require("../rogueDef-sidecar");
var rogueLayers_sidecar_1 = require("../scene/rogueLayers-sidecar");
var rogueTester_rogue_sidecar_1 = require("../scene/rogueTester_rogue-sidecar");
var rogueStats_sidecar_1 = require("../ui/rogueStats-sidecar");
var rogueMonsters_sidecar_1 = require("./rogueMonsters-sidecar");
var rogueMonstersAi_1 = require("./rogueMonstersAi");
var rogueMonstersAi_sidecar_1 = require("./rogueMonstersAi-sidecar");
var rogueMonstersData_sidecar_1 = require("./rogueMonstersData-sidecar");
var rogueMonsters_playerCustomization_1 = require("./rogueMonsters_playerCustomization");
var _objs = [];
var _flashTimeMax = 0.5;
var _flashTime = 0;
var _flashMode = 0;
var create = function (type) {
    var data = rogueMonstersData_sidecar_1.rogueMonstersData.get(type);
    if (!data) {
        throw new Error('no data for monster type: ' + type);
    }
    var image = spritesUtil_sidecar_1.spritesUtil.createImage(rogueLayers_sidecar_1.rogueLayers.getLayers().monsters, data.sprite[0]);
    image.scale = rogueDef_sidecar_1.rogueDef.scale;
    image.tint = data.color;
    var image2 = spritesUtil_sidecar_1.spritesUtil.createImage(rogueLayers_sidecar_1.rogueLayers.getLayers().monsters, data.sprite[0]);
    image2.scale = rogueDef_sidecar_1.rogueDef.scale;
    image2.visible = false;
    var image3 = spritesUtil_sidecar_1.spritesUtil.createImage(rogueLayers_sidecar_1.rogueLayers.getLayers().monsters, data.sprite[0]);
    image3.scale = rogueDef_sidecar_1.rogueDef.scale;
    image3.visible = false;
    var image4 = spritesUtil_sidecar_1.spritesUtil.createImage(rogueLayers_sidecar_1.rogueLayers.getLayers().monsters, data.sprite[0]);
    image4.scale = rogueDef_sidecar_1.rogueDef.scale;
    image4.visible = false;
    var imageStatus = spritesUtil_sidecar_1.spritesUtil.createImage(rogueLayers_sidecar_1.rogueLayers.getLayers().monsters, sprites_sidecar_1.sprites.rogue50[0]);
    imageStatus.scale = rogueDef_sidecar_1.rogueDef.scale;
    var c = {
        x: 0,
        y: 0,
        char: '@',
        frames: sprites_sidecar_1.sprites.rogue10,
        image: image,
        image2: image2,
        image3: image3,
        image4: image4,
        imageStatus: imageStatus,
        isPlayer: data.isPlayer,
        isDead: false,
        data: data,
        hp: data.maxHp,
        maxHp: data.maxHp,
        ai: rogueMonstersAi_sidecar_1.rogueMonstersAi.create(data.aiMode),
        inventory: [],
        // level: 1,
        // exp: 0,
    };
    _objs.push(c);
    return c;
};
exports.create = create;
var getPlayer = function () {
    return _objs.find(function (c) { return c.isPlayer; }) || null;
};
exports.getPlayer = getPlayer;
var setPos = function (c, x, y) {
    c.x = x;
    c.y = y;
    if (c.isPlayer) {
        var item = rogueItems_sidecar_1.rogueItems.getAt(x, y);
        if (item) {
            (0, exports.pickupItem)(c, item);
        }
        var feature = rogueDungeonFeatures_sidecar_1.rogueDungeonFeatures.getAt(x, y);
        if (feature) {
            rogueStats_sidecar_1.rogueStats.setMessage('You go down the stairs!');
            rogueTester_rogue_sidecar_1.rogueTester_rogue.nextLevel();
        }
    }
};
exports.setPos = setPos;
var pickupItem = function (c, item) {
    rogueItems_sidecar_1.rogueItems.pickupItem(c, item);
};
exports.pickupItem = pickupItem;
var kill = function (c) {
    c.isDead = true;
    c.image.visible = false;
    c.image2.visible = false;
    c.image3.visible = false;
    c.image4.visible = false;
    c.imageStatus.visible = false;
};
exports.kill = kill;
var killAllEvenIncludingThePlayer = function () {
    _objs.forEach(function (c) {
        (0, exports.kill)(c);
    });
    cleanup();
};
exports.killAllEvenIncludingThePlayer = killAllEvenIncludingThePlayer;
var killAllButPlayer = function () {
    _objs.forEach(function (c) {
        if (!c.isPlayer) {
            (0, exports.kill)(c);
        }
    });
    cleanup();
};
exports.killAllButPlayer = killAllButPlayer;
var cleanup = function () {
    entitiesUtils_sidecar_1.entitiesUtils.removeDead(_objs, function (c) {
        c.image.destroy();
        c.image2.destroy();
        c.image3.destroy();
        c.image4.destroy();
        c.imageStatus.destroy();
    });
};
var runAll = function () {
    var map = rogueMaps_sidecar_1.rogueMaps.getCurrentMap();
    _objs.forEach(function (c) {
        rogueMonstersAi_sidecar_1.rogueMonstersAi.run(c, map);
    });
};
exports.runAll = runAll;
var drawAll = function () {
    // let game = game2.getGame()
    cleanup();
    _flashTime += common_sidecar_1.common.getUpdateDelta();
    if (_flashTime > _flashTimeMax) {
        _flashTime = 0;
        _flashMode++;
    }
    var showStatus = _flashMode % 2 === 0;
    var map = rogueMaps_sidecar_1.rogueMaps.getCurrentMap();
    _objs.forEach(function (c) {
        rogueDef_sidecar_1.rogueDef.moveTileObj(c.image, c);
        rogueDef_sidecar_1.rogueDef.moveTileObj(c.image2, c);
        rogueDef_sidecar_1.rogueDef.moveTileObj(c.image3, c);
        rogueDef_sidecar_1.rogueDef.moveTileOffset(c.image4, c.x, c.y, 0, -0.5);
        rogueDef_sidecar_1.rogueDef.moveTileOffset(c.imageStatus, c.x, c.y, -0.5, -0.5);
        c.imageStatus.visible = false;
        if (c.ai.state === rogueMonstersAi_1.EAiState.Sleep) {
            spritesUtil_sidecar_1.spritesUtil.setPackedFrameSameScale(c.imageStatus, sprites_sidecar_1.sprites.rogue50[0]);
            c.imageStatus.visible = showStatus;
        }
        if (c.ai.isAlerted) {
            spritesUtil_sidecar_1.spritesUtil.setPackedFrameSameScale(c.imageStatus, rogueMonofont_sidecar_1.rogueMonofont.getSprite('!')[0]);
            c.imageStatus.visible = showStatus;
        }
        if (c.isPlayer) {
            (0, rogueMonsters_playerCustomization_1.setPlayerAppearance)(c);
        }
        else {
            var t = rogueMaps_sidecar_1.rogueMaps.getTile(map, c.x, c.y);
            if (t) {
                if (t.eVision === rogueMaps_1.EVision.Seen) {
                    c.image.visible = true;
                }
                else {
                    c.image.visible = false;
                    c.imageStatus.visible = false;
                }
            }
        }
    });
};
exports.drawAll = drawAll;
var getAt = function (x, y) {
    return _objs.find(function (c) { return c.x === x && c.y === y; }) || null;
};
exports.getAt = getAt;
function damage(c, amount) {
    c.hp -= amount;
    if (c.hp <= 0) {
        if (!c.isPlayer) {
            rogueStats_sidecar_1.rogueStats.setMessage("The ".concat(c.data.name, " dies!"));
        }
        (0, exports.kill)(c);
    }
}
exports.damage = damage;
function tryMoveOffset(c, ox, oy) {
    var x = c.x + ox;
    var y = c.y + oy;
    var map = rogueMaps_sidecar_1.rogueMaps.getCurrentMap();
    var usedUpMove = false;
    if (map) {
        var tile = rogueMaps_sidecar_1.rogueMaps.getTile(map, x, y);
        if (tile) {
            var eTile = tile.eTile;
            var m = rogueMonsters_sidecar_1.rogueMonsters.getAt(x, y);
            if (m) {
                // Attack!
                rogueStats_sidecar_1.rogueStats.setMessage('You attack the ' + m.data.name + '!');
                damage(m, 1);
                usedUpMove = true;
            }
            if (eTile === rogueMaps_1.ETile.Door) {
                rogueMaps_sidecar_1.rogueMaps.setTile(map, x, y, rogueMaps_1.ETile.DoorOpen);
                usedUpMove = true;
            }
            if (!usedUpMove) {
                if (eTile === rogueMaps_1.ETile.Floor ||
                    eTile === rogueMaps_1.ETile.Corridor ||
                    eTile === rogueMaps_1.ETile.DoorOpen) {
                    (0, exports.setPos)(c, x, y);
                }
                else {
                    rogueStats_sidecar_1.rogueStats.setMessage('You bump into a wall.');
                }
            }
        }
    }
}
exports.tryMoveOffset = tryMoveOffset;
var removeFromInventory = function (c, item) {
    assert_sidecar_1.assert.isIn(c.inventory, item);
    entitiesUtils_sidecar_1.entitiesUtils.remove(c.inventory, item);
    item.isInInventory = false;
};
exports.removeFromInventory = removeFromInventory;
